export const TYPE_CELLS = {
  NUMBER_CELL: "numberCellTemPlate",
  TIME_CELL: "timeCellTemPlate",
  DATE_TIME_CELL: "dateTimeCellTemPlate",
  DATE_CELL: "dateCellTemPlate",
  RICH_TEXT_CELL: "richTextCellTemPlate",
  SELECT_CELL: "selectCellTemPlate",
  RADIO_CELL: "radioCellTemPlate",
  CHECK_BOX_CELL: "checkBoxCellTemPlate",
  MULTI_CHOICE_CELL: "multiChoiceCellTemPlate",
  DROP_DOWN_CELL: "dropDownCellTemPlate",
  LINK_CELL: "linkCellTemPlate",
  ATTACHMENT_CELL: "attachmentCellTemPlate",
  TEXT_AREA_CELL: "textAreaCellTemplate",
  TABLE_TOGGLE_CELL: "tableToggleCellTemplate",
  TEXT_CELL: "textCellTemplate",
} as const;

export const DEFAULT_WIDTH_COL = 200;
